/** Integration management routes **/
import Layout from '@/layout';

const integrationRoutes = {
  path: '/integrations',
  component: Layout,
  redirect: '/integrations/ftp-requests',
  name: 'Integrations',
  alwaysShow: true,
  meta: {
    title: 'Integracje',
    icon: 'el-icon-connection',
    permissions: ['manage user'],
  },
  children: [
    {
      path: 'ftp-requests',
      component: () => import('@/views/integrations/FtpRequests'),
      name: 'FtpRequests',
      meta: { 
        title: 'Żądania FTP', 
        icon: 'el-icon-folder-opened',
        noCache: true, 
        permissions: ['manage user'] 
      },
    },
    {
      path: 'active',
      component: () => import('@/views/integrations/ActiveIntegrations'),
      name: 'ActiveIntegrations',
      meta: { 
        title: 'Aktywne konta', 
        icon: 'el-icon-folder-checked',
        noCache: true, 
        permissions: ['manage user'] 
      },
    },
    {
      path: 'integration-requests',
      component: () => import('@/views/integrations/IntegrationRequests'),
      name: 'IntegrationRequests',
      meta: { 
        title: 'Prośby o integracje', 
        icon: 'el-icon-message',
        noCache: true, 
        permissions: ['manage user'] 
      },
    },
    {
      path: 'import-logs',
      component: () => import('@/views/integrations/ImportLogs'),
      name: 'ImportLogs',
      meta: { 
        title: 'Logi importu', 
        icon: 'el-icon-document',
        noCache: true, 
        permissions: ['manage user'] 
      },
    },
    {
      path: 'ftp-status',
      component: () => import('@/views/integrations/FtpStatus'),
      name: 'FtpStatus',
      meta: { 
        title: 'Status FTP', 
        icon: 'el-icon-monitor',
        noCache: true, 
        permissions: ['manage user'] 
      },
    },
  ],
};

export default integrationRoutes;
